var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNegation = function SvgNegation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.35H.75l.37-1.6h4.5Zm6.68 4h-1.77v-.09a14.76 14.76 0 0 0-.59-1.49c-.21-.47-.42-.93-.64-1.38l-2.59 3h-2L8.15 8 6.1 4H8l1.32 2.8c.38-.46.74-.92 1.07-1.36a15 15 0 0 0 .95-1.37v-.06h1.87l-.13.19c-.45.65-.94 1.32-1.47 2s-1.02 1.28-1.55 1.9l1 2a18.47 18.47 0 0 1 .85 2.1Z"
  })));
};

export default SvgNegation;